export default __webpack_public_path__ + "static/media/shooting-envelope.e5e77c87.png";